<template>
    <v-tooltip top open-delay="250" color="primary">
        <template v-slot:activator="{ on }">

            <div v-on="on"
                 :style="'border-left: 5px solid ' +  incidenceColor"
                 class="display-1 pl-2">
                <span v-if="project.incidence_rate < 3">
                    {{ roundValue(incidenceRate, 1).toLocaleString() }}<span class="text-h5">%</span>
                </span>
                <span v-else>
                    {{ roundValue(incidenceRate,0).toLocaleString() }}<span class="text-h5">%</span>
                </span>

            </div>
        </template>
        <div v-if="project.estimated_incidence_rate > 0">
            Estimated incidence rate is: {{ project.estimated_incidence_rate }}%
            <br>
            Actual incidence rate is: {{ incidenceRate }}%
        </div>
        <div v-else>
            Incidence rate is: {{ incidenceRate }}%
        </div>

        <div>
            <div>
                Completes: {{ project.completed_count.toLocaleString() }}
            </div>

            <div>
                Terminates: {{ incidenceTerminatedCount.toLocaleString() }}
            </div>
        </div>
    </v-tooltip>
</template>

<script>

import Json from 'vue-json-pretty';
import {incidenceRateMixin} from "../../../components/mixins/incidenceRateMixin";
import {numberDisplay} from '../../../components/mixins/numberDisplayMixin';

export default {

    mixins: [incidenceRateMixin, numberDisplay],

    components: {
        Json
    },

    props: {
        project: {
            type: Object,
            required: true
        },
    },
}
</script>
